import { z } from 'zod';

export const QUEST_CLINICAL_NOTES_MAX_LENGTH = 120;

export const nativeDraftLabOrderSetToolInputSchema = z
  .object({
    labSlug: z.literal('quest'),
    collectionMethod: z.enum([
      'testkit',
      'walk_in_test',
      'at_home_phlebotomy',
      'on_site_collection',
    ]),
    markerIds: z.array(z.string().min(1)).min(1),
    icdCodes: z.array(z.object({ code: z.string().min(1), description: z.string() })).min(1),
    notes: z.string().optional(),
    priority: z.boolean().optional(),
  })
  .strict();

export const nativeDraftLabOrderSetToolInputWriteSchema =
  nativeDraftLabOrderSetToolInputSchema.extend({
    notes: z.string().max(QUEST_CLINICAL_NOTES_MAX_LENGTH).optional(),
  });
